module.exports = __webpack_public_path__ + "static/Rosewater0-202970bb07d3ba7b6fa3c0c4e27b0596.webp";